import { motion } from 'framer-motion'

/**
 * Branded loading state: the app logo gently pulsing. Used while a quick async
 * check (e.g. resolving a hotel's plan) is in flight, instead of flashing the
 * wrong screen.
 */
export function LogoSpinner({ fullScreen = true }: { fullScreen?: boolean }) {
  return (
    <div
      className={`flex items-center justify-center bg-app dark:bg-app-dark ${
        fullScreen ? 'min-h-screen' : 'py-20'
      }`}
    >
      <motion.img
        src="/favicon.svg"
        alt="Loading"
        className="w-14 h-14"
        animate={{ scale: [1, 1.12, 1], opacity: [0.55, 1, 0.55] }}
        transition={{ duration: 0.9, repeat: Infinity, ease: 'easeInOut' }}
      />
    </div>
  )
}
